<template>
  <section v-if="shopifyData.imgDesktop" class="product_meta_image" :class="shopifyData.imageClass">
    <img
      class="imgDesktop"
      :src="shopifyData.imgDesktop"
      :alt="shopifyData.imgDesktop.alt || 'Product Image'"
      loading="lazy"
      aria-hidden="true"
      aria-label="product image"
      width=""
      height=""
    />
    <img
      class="imgMob"
      :src="shopifyData.imgMob"
      :alt="shopifyData.imgMob.alt || 'Product Image'"
      loading="lazy"
      aria-hidden="true"
      aria-label="product image"
      width=""
      height=""
    />
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.product_meta_image.no_meta_image {
  display: none;
}

.imgDesktop {
  display: block;
}

.imgMob {
  display: none;
}

@media only screen and (max-width: 768px) {
  .imgDesktop {
    display: none;
  }

  .imgMob {
    display: block;
  }
}
</style>
